import { render } from "./Profil.vue?vue&type=template&id=9690af60&scoped=true"
import script from "./Profil.vue?vue&type=script&lang=ts"
export * from "./Profil.vue?vue&type=script&lang=ts"

import "./Profil.vue?vue&type=style&index=0&id=9690af60&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9690af60"

export default script